<template>
  <div class="subpage-header">
    <container>
      <div class="subpage-header__wrp">
        <div class="subpage-header__left">
                    <h1 >
            <slot name="bread" />
          </h1>
          <h1 class="subpage-header__title color-white">
            <slot name="title" />
          </h1>         
          <slot name="text"/>
          <slot name="button"/>
          <slot name="numbers"/>
        </div>
        <div class="subpage-header__right">
          <img v-if="!hideShapes" src="@/assets/img/shapes/shape-11.svg" alt="izmir yurt" class="shape-11">
          <img v-if="!hideShapes" src="@/assets/img/shapes/shape-12.svg" alt="izmir yurt" class="shape-12">
          <svg class="shape-13" version="1.1" x="0px" y="0px" viewBox="0 0 838.1 166.8">
            <path class="st0" d="M3.2,166.8L88.6,39.6C105.2,14.9,133,0,162.8,0h353.6c23.6,0,46.2,9.4,62.8,26.2l45.8,46h28.2  c17.4,0,34.1,7,46.4,19.3l16.9,17h47.2c9.9,0,19.3,3.9,26.3,10.9l47.2,47.4H3.2z"/>
          </svg>
          <slot name="right"/>
          <img :src="cityIcon" alt="izmir yurtlar" v-if="cityIcon" class="subpage-header__img">
        </div>
      </div>
    </container>
  </div>
</template>

<script>
// import Shape from '@/assets/img/shapes/shape-13.svg'
export default {
  name: 'SubpageHeader',
  props: {
    cityIcon: String,
    hideShapes: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/components/subpage-header";
</style>
